import { createGameMap as createGameMapApi, updateGameMap as updateGameMapApi } from '../../services/api';
import { toast } from 'react-toastify';

export const saveGameMap = async (mapObject, selectedBot, selectedHexagons, lastGridCenter, mapNumber = 1) => {
	if (!mapObject || !selectedBot) {
		toast.error('Missing map or bot data', { position: "top-right" });
		return null;
	}

	// Use the stored grid center coordinates
	const gridCenterCoords = lastGridCenter || [mapObject.getCenter().lng, mapObject.getCenter().lat];
		
	const dropPoints = Array.from(selectedHexagons.values()).map(({ q, r, centerCoordinate }) => ({
		q,
		r,
		centerCoordinate
	}));

	const data = {
		game_map: {
			map_number: mapNumber,
			center_coordinate: gridCenterCoords,
			drop_points: dropPoints,
			bot_id: selectedBot.id
		}
	};

	try {
		const response = await createGameMapApi({ data });
		
		if (response.status >= 400) {
			toast.error('Failed to save game map', { position: "top-right" });
			return null;
		}
		
		toast.success('Game map saved successfully', { position: "top-right" });
		return response.data.id;
	} catch (error) {
		console.error('Error saving game map:', error);
		toast.error('Failed to save game map', { position: "top-right" });
		return null;
	}
};

export const updateGameMapData = async (mapObject, selectedBot, selectedHexagons, lastGridCenter, mapNumber, gameMapId) => {
	if (!mapObject || !selectedBot) {
		toast.error('Missing map or bot data', { position: "top-right" });
		return;
	}

	// Use the stored grid center coordinates
	const gridCenterCoords = lastGridCenter || [mapObject.getCenter().lng, mapObject.getCenter().lat];
		
	const dropPoints = Array.from(selectedHexagons.values()).map(({ q, r, centerCoordinate }) => ({
		q,
		r,
		centerCoordinate
	}));

	const data = {
		game_map: {
			map_number: mapNumber,
			center_coordinate: gridCenterCoords,
			drop_points: dropPoints,
			bot_id: selectedBot.id
		}
	};

	try {
		const response = await updateGameMapApi({ data, id: gameMapId });
		
		if (response.status >= 400) {
			toast.error('Failed to update game map', { position: "top-right" });
			return;
		}
		
		toast.success('Game map updated successfully', { position: "top-right" });
	} catch (error) {
		console.error('Error updating game map:', error);
		toast.error('Failed to update game map', { position: "top-right" });
	}
};

export const formatGameMapData = (selectedHexagons, mapObject, lastGridCenter, selectedBot, mapNumber) => {
	const gridCenterCoords = lastGridCenter || [mapObject.getCenter().lng, mapObject.getCenter().lat];
	
	const dropPoints = Array.from(selectedHexagons.values()).map(({ q, r, centerCoordinate }) => ({
		q,
		r,
		centerCoordinate
	}));

	return {
		game_map: {
			map_number: mapNumber,
			center_coordinate: gridCenterCoords,
			drop_points: dropPoints,
			bot_id: selectedBot.id
		}
	};
};